import { ButtonTooltip } from '../types/notification-settings-types';

export const getOrgNotificationButtonTooltip = (
  notificationEnabled: boolean,
) => {
  return notificationEnabled
    ? ButtonTooltip.DisableOrgNotifications
    : ButtonTooltip.EnableOrgNotifications;
};

export const getUserNotificationButtonTooltip = (
  isUserUnsubscribed: boolean,
  notificationEnabled: boolean,
) => {
  if (!notificationEnabled) {
    return ButtonTooltip.PleaseEnableOrgNotifications;
  }

  return isUserUnsubscribed
    ? ButtonTooltip.EnableUserNotifications
    : ButtonTooltip.DisableUserNotifications;
};

export const getTestEmailTooltip = (notificationEnabled: boolean) => {
  return notificationEnabled
    ? ButtonTooltip.SendTestEmail
    : ButtonTooltip.PleaseEnableOrgNotifications;
};

export const getNotifyAllTooltip = (
  isUserAdminRole: boolean,
  notificationEnabled: boolean,
  notifyAll: boolean,
) => {
  if (!isUserAdminRole) {
    return ButtonTooltip.ReadOnlyNotAllowedForAction;
  }

  if (!notificationEnabled) {
    return ButtonTooltip.PleaseEnableOrgNotifications;
  }

  if (notifyAll) {
    return ButtonTooltip.EnableLimitMemberNotification;
  }

  return ButtonTooltip.DisableLimitMemberNotification;
};

export const getRecipientsAutocompleteTooltip = (
  isUserAdminRole: boolean,
  notificationEnabled: boolean,
  notifyAll: boolean,
) => {
  if (!isUserAdminRole) {
    return ButtonTooltip.ReadOnlyNotAllowedForAction;
  }

  if (!notificationEnabled) {
    return ButtonTooltip.PleaseEnableOrgNotifications;
  }

  if (notifyAll) {
    return ButtonTooltip.AllOrgMembersAreNotified;
  }

  return '';
};
